import { ControlType, unbindParameterName } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { ProcessTemplatesParameterSelector } from "~/areas/platformHub/processEditor/ProcessTemplatesParameterSelector";
import { TargetTagsProcessEditorContextualHelp } from "~/components/ContextualHelp/ContextualHelpSnippets";
import { ExpandableFormSection, Summary } from "~/components/form/index";
export type TargetTagsParameterSelectProps = {
    selectedTargetTagParameter: string | undefined;
    onTargetTagParameterChanged: (parameter: string | undefined) => void;
    error: string | undefined;
};
export type TargetTagsParameterFormSectionProps = {
    expandedByDefault: boolean;
    selectedTargetTagParameter: string | undefined;
    onTargetTagParameterChanged: (parameter: string | undefined) => void;
    error: string | undefined;
    isKubernetesStep: boolean;
};
export const TargetTagsParameterSelect = ({ selectedTargetTagParameter, onTargetTagParameterChanged, error }: TargetTagsParameterSelectProps) => {
    return <ProcessTemplatesParameterSelector selectedParameter={selectedTargetTagParameter} onParameterChange={(value) => onTargetTagParameterChanged(value ?? undefined)} controlType={ControlType.TargetTags} allowClear={false} error={error}/>;
};
export const TargetTagsParameterFormSection = ({ error, expandedByDefault, onTargetTagParameterChanged, selectedTargetTagParameter, isKubernetesStep }: TargetTagsParameterFormSectionProps) => {
    return (<ExpandableFormSection isExpandedByDefault={expandedByDefault} summary={TargetTagParameterSummary(selectedTargetTagParameter)} title={"Target Tags"} errorKey="Octopus.Action.TargetRoles" help={<span>This step will deploy to {isKubernetesStep ? "Kubernetes clusters" : "deployment targets"} with any matching tags specified in the project.</span>} contextualHelp={<TargetTagsProcessEditorContextualHelp />}>
            <TargetTagsParameterSelect selectedTargetTagParameter={selectedTargetTagParameter} onTargetTagParameterChanged={onTargetTagParameterChanged} error={error}/>
        </ExpandableFormSection>);
};
export const TargetTagParameterSummary = (selectedBindedTargetTagParameter: string | undefined) => {
    const targetTagParameterName = unbindParameterName(selectedBindedTargetTagParameter);
    return targetTagParameterName
        ? Summary.summary(<span>
                  Using parameter <strong>{targetTagParameterName}</strong>
              </span>)
        : Summary.placeholder("No parameter selected");
};
